<header class="bg-dc-gradient h-auto py-6">
  @if(parentRouteName == "service" || showBackButtonText){
  <button type="button" (click)="back()" class="absolute left-4 rtl:left-auto rtl:right-4 flex items-center gap-2 text-white">
    <img src="/icons/svg/back.svg" class="rtl:rotate-180">
    @if (showBackButtonText) {
      <span class="underline underline-offset-4 pb-1">{{ "BACK" | translate }}</span>
    }
  </button>
  }
  <!-- Centered logo -->
  <div class="absolute left-1/2 transform -translate-x-1/2">
     <img
       [src]="currentLogo"
       alt="Logo"
       class="lg:block select-none"
       (dblclick)="onLogoDoubleClick($event)"
     />
  </div>
</header>

<div class="flex flex-col bg-gray-100">
    <router-outlet></router-outlet>
</div>
